import React, { useState, useEffect } from 'react';
import { useAuthStore }                from '../../store/authStore';

const AdminTopBar: React.FC = () => {
  const logout               = useAuthStore(s => s.logout);
  const [open, setOpen]      = useState(false);

  useEffect(() => {
    const close = () => setOpen(false);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  return (
    <div id="admin-topbar" style={{position:'fixed',top:10,right:28,zIndex:9999}}>
      <div className="at-hamburger"
        onClick={e => { e.stopPropagation(); setOpen(o => !o); }}
        title="Menu">
        <span /><span /><span />
      </div>
      {open && (
        <div className="at-dropdown open" onClick={e => e.stopPropagation()}>
          <div className="at-menu-header">
            <img src="/img/SGK_logo.png" className="at-menu-logo" alt="SGK" />
            <div>
              <div className="at-menu-admin-label">Admin<span className="at-dot" /></div>
            </div>
          </div>
          <div className="at-menu-item logout"
            onClick={() => { setOpen(false); if (confirm('Log out of admin?')) logout(); }}>
            <svg viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" fill="none">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            Log Out
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminTopBar;